// extracted by mini-css-extract-plugin
export var cardHeader = "_fl-1";
export var contentCard = "_fl-0";
export var headerActions = "_fl-3";
export var reorderHandle = "_fl-5";
export var titleArea = "_fl-2";
export var titleAreaWithHandle = "_fl-4";